module.exports = __webpack_public_path__ + "img/Desk Stationary A34.0864f742.jpg";